import React from "react";
import { useTranslation } from "../../i18n/useTranslation";

const HomeTestimonials = () => {
  const { t } = useTranslation();
  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 font-medium uppercase rounded-full">
            {t("testimonialsTag")}
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            {t("testimonialsTitle")}
          </h2>
          <p className="mb-20 text-base md:text-lg text-slate-500">
            {t("testimonialsDesc")}
          </p>
        </div>
        <div className="flex flex-wrap -mx-4 text-slate-800 gap-y-16">
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                {t("testimonial1Text")}
              </h3>
              <div className="flex-1"></div>
              <p className="font-bold mb-2">{t("testimonial1Name")}</p>
              <p className="text-slate-500">{t("testimonial1Position")}</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                {t("testimonial2Text")}
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">{t("testimonial2Name")}</p>
              <p className="text-slate-500">{t("testimonial2Position")}</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                {t("testimonial3Text")}
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">{t("testimonial3Name")}</p>
              <p className="text-slate-500">{t("testimonial3Position")}</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                {t("testimonial4Text")}
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">{t("testimonial4Name")}</p>
              <p className="text-slate-500">{t("testimonial4Position")}</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                {t("testimonial5Text")}
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">{t("testimonial5Name")}</p>
              <p className="text-slate-500">{t("testimonial5Position")}</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                {t("testimonial6Text")}
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">{t("testimonial6Name")}</p>
              <p className="text-slate-500">{t("testimonial6Position")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
